<template>
  <div>
    <div class="col-12 col-xl-9">
      <div class="row">
        <div class="col-12 text-primary">
          <p>
            Manche Einstellungen können nur von Kundensupport geändert werden.
            Wenn du Änderungswünsche hast kontaktiere uns
            <a href="/Kundensupport">hier</a>.
          </p>
          <resource
            title="Ändern"
            resource="customerProfile"
            :original="customer"
            :attributes="attributes"
            header-class="d-none"
          >
          </resource>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      attributes: []
    };
  },
  computed: {
    customer() {
      let customer = Laravel.user.customer_profile;
      customer.privacyPostalCodeNumbers =
        Laravel.user.settings["privacyPostalCodeNumbers"];
      return customer;
    }
  },
  created() {
    let zipcodeNumbers = [];
    if (this.customer.zipcode) {
      for (var i = 1; i <= this.customer.zipcode.length; i++) {
        zipcodeNumbers.push({ value: i, text: i });
      }
    }

    this.attributes = [
      {
        name: "sex",
        label: "Geschlecht",
        type: "SexSelector",
        disabled: this.customer.sex ? true : false
      },
      {
        name: "name",
        label: "Name",
        type: "StaticText",
        checkChanged: true
      },
      {
        name: "country_iso3166",
        label: "Land",
        type: "OptionSelector",
        disabled: true
      },
      {
        name: "zipcode",
        label: "PLZ",
        col: 5,
        type: this.customer.zipcode ? "StaticText" : "PostcodeSelector"
      },
      {
        name: "privacyPostalCodeNumbers",
        label: "Angezeigte Stellen der Postleitzahl:",
        type: "DropdownSelector",
        items: zipcodeNumbers,
        hidden: this.customer.zipcode ? false : true
      },
      {
        name: "birthday",
        label: "Geburtsdatum",
        type: this.customer.birthday ? "StaticText" : "BirthdaySelector",
        withRandomSelector: false,
        onlyDate: true
      },
      {
        name: "physique",
        label: "Figur",
        type: "OptionSelector"
      },
      {
        name: "i_search_for_activity",
        label: "Ich suche",
        type: "MultiOptionSelector",
        multiSelect: true
      },
      {
        name: "interested_in_gender",
        label: "Interessiert an",
        type: "SexSelector",
        multiSelect: true
      },
      {
        name: "height_in_cm",
        label: "Größe (cm)",
        type: "SliderSelector",
        max: 220,
        min: 140
      }
    ];
  }
};
</script>
